import { cn } from '@/lib/utils'
import type { ReactNode } from 'react'

type BadgeVariant = 'gold' | 'teal' | 'ember' | 'green' | 'orange' | 'red' | 'blue'

interface BadgeProps {
  children: ReactNode
  variant?: BadgeVariant
  size?: 'sm' | 'md'
  className?: string
}

const variants: Record<BadgeVariant, string> = {
  gold:   'bg-light-gold text-ochre border border-[#F0E6C0]',
  teal:   'bg-teal/10 text-teal border border-teal/20',
  ember:  'bg-ember text-[var(--color-gold)]',
  green:  'bg-emerald-50 text-emerald-700 border border-emerald-200',
  orange: 'bg-orange/10 text-orange border border-orange/20',
  red:    'bg-red-50 text-red-600 border border-red-200',
  blue:   'bg-blue-50 text-blue-700 border border-blue-200',
}

const sizes = {
  sm: 'px-2 py-0.5 text-[10px]',
  md: 'px-2.5 py-0.5 text-xs',
}

export function Badge({ children, variant = 'gold', size = 'md', className }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full font-bold',
        variants[variant],
        sizes[size],
        className
      )}
    >
      {children}
    </span>
  )
}
